import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextBlock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTextBlock"><Path d="M3.5 4.5H8.5V9.5H3.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 14.5H8.5V19.5H3.5V14.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 5.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 8.5H17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 15.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 18.5H17.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTextBlock;
